import { connect } from 'react-redux';
import EnablePayoneer from 'account/components/payout/enable_payoneer';
import { enablePayoneer } from 'common/ducks/payout';

const mapStateToProps = ({ payout }) => {
  return {
    enabled: payout.payoneerEnabled
  };
}

export default connect(mapStateToProps, {
  enable: enablePayoneer
})(EnablePayoneer);



// WEBPACK FOOTER //
// ./account/containers/payout/enable_payoneer.js